var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAllCommunityIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#F0F2F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.72 32.328H43.515v20.451H53.72V32.328z",
    fill: "#9EA3B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.006 53.063H43.238V32.036h10.777v21.027h-.01zm-10.208-.576h9.647V32.612h-9.647v19.875z",
    fill: "#2D344B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.66 46.203h-1.928v1.981h1.928v-1.98z",
    fill: "#FFFAE5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.945 48.477h-2.488V45.92h2.488v2.557zm-1.937-.576h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.513 46.203h-1.927v1.98h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.798 48.477H41.31V45.92h2.488v2.557zm-1.927-.576h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M47.369 46.203H45.44v1.98h1.928v-1.98z",
    fill: "#FFFAE5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M47.654 48.477h-2.488V45.92h2.488v2.557zm-1.928-.576h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.234 46.203h-1.927v1.98h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.519 48.477H49.03V45.92h2.488v2.557zm-1.927-.576h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M39.66 34.33h-1.928v1.98h1.928v-1.98z",
    fill: "#FFFAE5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.945 36.601h-2.488v-2.556h2.488V36.6zm-1.937-.575h1.367V34.62h-1.367v1.405z",
    fill: "#2D344B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.513 34.33h-1.927v1.98h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43.798 36.601H41.31v-2.556h2.488V36.6zm-1.927-.575h1.367V34.62h-1.367v1.406z",
    fill: "#2D344B"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M47.369 34.33H45.44v1.98h1.928v-1.98z",
    fill: "#FFFAE5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.654 36.601h-2.488v-2.556h2.488V36.6zm-1.928-.575h1.367V34.62h-1.367v1.406z",
    fill: "#2D344B"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.234 34.33h-1.927v1.98h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M51.519 36.601H49.03v-2.556h2.488V36.6zm-1.927-.575h1.367V34.62h-1.367v1.406z",
    fill: "#2D344B"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.66 38.29h-1.928v1.98h1.928v-1.98z",
    fill: "#FFFAE5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M39.945 40.563h-2.488v-2.556h2.488v2.556zm-1.937-.576h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.513 38.29h-1.927v1.981h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M43.798 40.563H41.31v-2.556h2.488v2.556zm-1.927-.576h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M47.369 38.29H45.44v1.981h1.928v-1.98z",
    fill: "#FFFAE5"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M47.654 40.563h-2.488v-2.556h2.488v2.556zm-1.928-.576h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M51.234 38.29h-1.927v1.981h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.519 40.563H49.03v-2.556h2.488v2.556zm-1.927-.576h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M39.66 42.261h-1.928v1.98h1.928v-1.98z",
    fill: "#FFFAE5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.945 44.533h-2.488v-2.566h2.488v2.566zm-1.937-.585h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M43.513 42.261h-1.927v1.98h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M43.798 44.534H41.31v-2.567h2.488v2.567zm-1.927-.586h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M47.369 42.261H45.44v1.98h1.928v-1.98z",
    fill: "#FFFAE5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.654 44.533h-2.488v-2.566h2.488v2.566zm-1.928-.585h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.234 42.261h-1.927v1.98h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.519 44.534H49.03v-2.567h2.488v2.567zm-1.927-.586h1.367v-1.405h-1.367v1.405z",
    fill: "#2D344B"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M25.02 28.006h-6.75V52.78h6.75V28.006z",
    fill: "#9EA3B7"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M25.305 53.061h-7.31V27.712h7.31v25.35zm-6.75-.575h6.18V28.288h-6.19v24.198h.01z",
    fill: "#2D344B"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M22.691 30.366h-1.927v1.98h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M22.976 32.63h-2.488v-2.556h2.488v2.556zm-1.937-.575h1.367V30.65H21.04v1.405z",
    fill: "#2D344B"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M22.691 34.33h-1.927v1.98h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.976 36.601h-2.488v-2.556h2.488V36.6zm-1.937-.575h1.367V34.62H21.04v1.406z",
    fill: "#2D344B"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M22.691 38.29h-1.927v1.981h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M22.976 40.563h-2.488v-2.556h2.488v2.556zm-1.937-.576h1.367v-1.404H21.04v1.404z",
    fill: "#2D344B"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M22.691 42.261h-1.927v1.981h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M22.976 44.534h-2.488v-2.566h2.488v2.566zm-1.937-.586h1.367v-1.405H21.04v1.405z",
    fill: "#2D344B"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M22.691 46.223h-1.927v1.981h1.927v-1.98z",
    fill: "#FFFAE5"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M22.976 48.496h-2.488V45.94h2.488v2.556zm-1.937-.575h1.367v-1.405H21.04v1.405z",
    fill: "#2D344B"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M40.049 16.373H28.475v3.096h11.574v-3.096z",
    fill: "#FFDA80"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M40.334 19.798H28.199v-3.743h12.135v3.743zm-11.575-.658h11.015v-2.437H28.759v2.437z",
    fill: "#2D344B"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M37.161 13.289H31.37v3.096h5.792v-3.096z",
    fill: "#2D344B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M37.436 16.703h-6.342V12.96h6.352v3.743h-.01zm-5.782-.647h5.222v-2.437h-5.222v2.437z",
    fill: "#2D344B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M43.512 19.47H25.016v33.274h18.496V19.47z",
    fill: "#C6C9D5"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M43.789 53.062H24.732V19.14H43.79v33.922zm-18.487-.647H43.23V19.799H25.302v32.616z",
    fill: "#2D344B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.163 46.223h-5.792v6.557h5.792v-6.557z",
    fill: "#FFFAE5"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M37.438 53.063h-6.342V45.93h6.352v7.133h-.01zm-5.782-.576h5.222v-5.971h-5.222v5.971z",
    fill: "#2D344B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M34.545 46.223h-.56v6.557h.56v-6.557zM41.017 22.913H27.517v.575h13.502v-.575zM41.017 25.888H27.517v.576h13.502v-.576zM41.017 28.865H27.517v.575h13.502v-.575zM41.017 31.84H27.517v.576h13.502v-.576zM41.017 34.807H27.517v.576h13.502v-.576zM41.017 37.783H27.517v.576h13.502v-.576zM41.017 40.758H27.517v.575h13.502v-.575zM41.017 43.734H27.517v.576h13.502v-.576zM29.5 46.71h-1.984v.575H29.5v-.576zM41.018 46.71h-1.985v.575h1.985v-.576z",
    fill: "#2D344B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M57.927 48.095v-.162l-.16-.033c-1.515-.315-2.674-1.73-2.674-3.436v-3.582c0-1.94 1.496-3.502 3.314-3.502s3.315 1.561 3.315 3.502v3.582c0 1.706-1.16 3.121-2.675 3.436l-.16.033v4.444c0 .295-.224.516-.48.516-.255 0-.48-.221-.48-.516v-4.282zM13.114 48.095v-.163l-.159-.032c-1.516-.315-2.675-1.73-2.675-3.436v-3.582c0-1.941 1.497-3.502 3.315-3.502 1.817 0 3.314 1.561 3.314 3.502v3.582c0 1.706-1.159 3.121-2.675 3.436l-.16.032v4.445c0 .295-.224.516-.48.516-.255 0-.48-.221-.48-.516v-4.282z",
    fill: "#576183",
    stroke: "#2D344B",
    strokeWidth: 0.4
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllCommunityIllustration);
export default __webpack_public_path__ + "static/media/all-community-illustration.260e98f0737715c8f3c9d5e7e151bc25.svg";
export { ForwardRef as ReactComponent };